import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { FacilitiesAccessor } from "../services/accessors/facilities.accessor";
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { defaultIfEmpty, filter, map, mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { UserModel } from 'src/app/models/user';

import { UserFacade } from 'src/app/services/facades/user/user.facade';
import { FacilitiesFacade } from '../services/facades/facilities/facilities.facade';

@Injectable({providedIn: 'root'})
export class FacilityResolver implements Resolve<any>{
    constructor(
        private facilitiesFacade: FacilitiesFacade,
        private router: Router,
    ) { }
    resolve(): Observable<any> {
        return this.facilitiesFacade.binder.activeFacility$.pipe(
            filter((facility) => !!facility),
            take(1)
        );
    }

          
}